import { PutUsersIntegrationRequestModel } from "@/features/user/services/put-integration-model";
import { PutUsersIntegrationApi } from "@/features/user/services/put-integration-api";

// 利用者統合処理
export class PutUsersIntegrationService {
  private putUsersIntegrationApi = new PutUsersIntegrationApi();
  /**
   * 利用者統合API実行
   */
  public async putUsersIntegration(param: PutUsersIntegrationRequestModel) {
    return await this.putUsersIntegrationApi.putUsersIntegration(param);
  }
}
